import { render } from "./L2_rank.vue?vue&type=template&id=23aaf08c&scoped=true"
import script from "./L2_rank.vue?vue&type=script&lang=js"
export * from "./L2_rank.vue?vue&type=script&lang=js"

import "./L2_rank.vue?vue&type=style&index=0&id=23aaf08c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23aaf08c"]])

export default __exports__